import { render, staticRenderFns } from "./report-on-sub-task.vue?vue&type=template&id=67adc312&"
import script from "./report-on-sub-task.vue?vue&type=script&lang=js&"
export * from "./report-on-sub-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports